export default [
  {
    path: '/main/arena/clean-triggered-events',
    meta: {
      tag: 'list_arena_clean_triggered_events',
      name: 'Limpar Eventos Disparados',
      breadcrumb: 'Limpar Eventos Disparados'
    },
    component: () => import(/* webpackChunkName: "arena-clean-triggered-event-list" */ '@/views/main/settings/arena/clean-triggered-events/Index.vue'),
    children: [
      {
        path: '',
        name: 'listarenacleantriggeredevent',
        meta: {
          tag: 'list_arena_clean_triggered_events',
          menu: 'settings',
          name: 'Limpar Eventos Disparados'
        },
        component: () => import(/* webpackChunkName: "arena-clean-triggered-event-list" */ '@/views/main/settings/arena/clean-triggered-events/List.vue'),
      }
    ]
  }
]
